export default __webpack_public_path__ + "static/media/key3.30f5d60d.png";